import { useEffect, useState } from "react";
import { useVendorAuth } from "../../store/vendorAuthStore";
import { vendorAuthApi } from "../../services/auth";
import { vendorApi } from "../../services/vendorApi";
import "../Auth/auth.css";

export default function StoreProfile() {
  const { token, vendor, setVendor } = useVendorAuth();

  const [form, setForm] = useState({
    shop_name: "", owner_name: "", phone: "",
    email: "", gst: "", pan: "", udyam: "",
    years_in_business: "", business_type: "",
  });

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [msg,     setMsg]     = useState("");
  const [isErr,   setIsErr]   = useState(false);

  // ✅ Fetch fresh from DB on mount
  useEffect(() => {
    const vendorId = vendor?.id || vendor?.vendor_id ||
      (() => { try { return JSON.parse(localStorage.getItem("vendor_me") || "{}")?.id || ""; } catch { return ""; } })();
    const authToken = token || localStorage.getItem("vendor_token") || "";

    if (!vendorId) { setFetching(false); return; }

    (async () => {
      try {
        const v = await vendorAuthApi.getProfile(vendorId, authToken);
        setForm({
          shop_name:         v.shop_name         || "",
          owner_name:        v.owner_name        || "",
          phone:             v.phone             || "",
          email:             v.email             || "",
          gst:               v.gst               || "",
          pan:               v.pan               || "",
          udyam:             v.udyam             || "",
          years_in_business: v.years_in_business || "",
          business_type:     v.business_type     || "",
        });
        setVendor(v);
      } catch (e) {
        // fallback to cached
        if (vendor) {
          setForm({
            shop_name:         vendor.shop_name         || "",
            owner_name:        vendor.owner_name        || "",
            phone:             vendor.phone             || "",
            email:             vendor.email             || "",
            gst:               vendor.gst               || "",
            pan:               vendor.pan               || "",
            udyam:             vendor.udyam             || "",
            years_in_business: vendor.years_in_business || "",
            business_type:     vendor.business_type     || "",
          });
        }
      } finally {
        setFetching(false);
      }
    })();
  }, []); // eslint-disable-line

  const set = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));
  const businessTypes = ["Individual", "Proprietorship", "Partnership", "LLP", "Pvt Ltd"];

  const submit = async (e) => {
    e.preventDefault();
    if (!form.shop_name.trim())  { setMsg("Shop Name required");  setIsErr(true); return; }
    if (!form.owner_name.trim()) { setMsg("Owner Name required"); setIsErr(true); return; }
    if (!form.phone.trim())      { setMsg("Phone required");      setIsErr(true); return; }

    setMsg(""); setIsErr(false);
    setLoading(true);
    try {
      await vendorApi.updateStore(token, form);
      setVendor(form);
      setMsg("Store profile updated successfully.");
      setIsErr(false);
    } catch (err) {
      setMsg(err.message || "Update failed.");
      setIsErr(true);
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div className="ep-page">
        <div className="ep-card" style={{ textAlign: "center", padding: 48, color: "var(--color-text-secondary)" }}>
          ⏳ Loading store profile...
        </div>
      </div>
    );
  }

  return (
    <div className="ep-page">
      <div className="ep-head">
        <div className="ep-icon-box">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        </div>
        <div>
          <h2 className="ep-title">Store Profile</h2>
          <div className="ep-sub">Update your store information</div>
        </div>
      </div>

      <div className="ep-card">
        <div className="ep-section-title">Store Information</div>
        {msg && <div className={`v-alert ${isErr ? "v-alert-error" : "v-alert-ok"}`}>{msg}</div>}

        <form onSubmit={submit}>
          <div className="ep-grid2">
            <div className="ep-field">
              <label className="ep-label">Shop Name</label>
              <input className="ep-input" value={form.shop_name} onChange={set("shop_name")} placeholder="Enter shop name" />
            </div>
            <div className="ep-field">
              <label className="ep-label">Owner Name</label>
              <input className="ep-input" value={form.owner_name} onChange={set("owner_name")} placeholder="Enter owner name" />
            </div>
            <div className="ep-field">
              <label className="ep-label">Phone</label>
              <input className="ep-input" value={form.phone} onChange={set("phone")} placeholder="Enter phone number" />
            </div>
            <div className="ep-field">
              <label className="ep-label">Email</label>
              <input className="ep-input" type="email" value={form.email} onChange={set("email")} placeholder="Enter email" />
            </div>
            <div className="ep-field">
              <label className="ep-label">GST Number (optional)</label>
              <input className="ep-input" value={form.gst} onChange={set("gst")} placeholder="Enter GST number" />
            </div>
            <div className="ep-field">
              <label className="ep-label">PAN Number</label>
              <input className="ep-input" value={form.pan} onChange={set("pan")} placeholder="Enter PAN number" />
            </div>
            <div className="ep-field">
              <label className="ep-label">UDYAM/MSME (optional)</label>
              <input className="ep-input" value={form.udyam} onChange={set("udyam")} placeholder="Enter UDYAM number" />
            </div>
            <div className="ep-field">
              <label className="ep-label">Years in Business</label>
              <input className="ep-input" value={form.years_in_business} onChange={set("years_in_business")} placeholder="e.g. 3" />
            </div>
          </div>
          <div className="ep-divider" />
          <div className="ep-field">
            <label className="ep-label">Business Type</label>
            <div className="ep-radio-group">
              {businessTypes.map(bt => (
                <label key={bt} className={`ep-radio-opt${form.business_type === bt ? " active" : ""}`}>
                  <input type="radio" checked={form.business_type === bt}
                    onChange={() => setForm(p => ({ ...p, business_type: bt }))} />
                  {bt}
                </label>
              ))}
            </div>
          </div>
          <div className="ep-footer">
            <button className="ep-next-btn" type="submit" disabled={loading}>
              {loading ? "Saving..." : "Save Changes →"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}